<template>
  <section>
    <q-field
      :label="!hideLabel ? $t('phone') : ''"
      :labelWidth="2"
      :icon="showIcon ? 'phone' : undefined"
      class="q-field-force-input"
    >
      <div class="row gutter-sm">
        <!-- Phone Number -->
        <div :class="columnWidth">
          <q-field
            class="no-margin"
            :error="errors.has('phone_' + id)"
            :error-label="errors.first('phone_' + id)"
          >
            <q-input
              type="tel"
              v-model="phone.number"
              v-validate.disable="{ max: 255, regex:/^[ 0-9A-z.,\+\-()/*#]*$/ }"
              :name="'phone_' + id"
              :data-vv-as="$t('phone')"
              :placeholder="$t('phone')"
            />
          </q-field>
        </div>

        <!-- Phone Number Label -->
        <div :class="columnWidth" v-show="!isEmpty && label">
          <q-field
            class="no-margin"
            :error="errors.has('phoneLabel_' + id)"
            :error-label="errors.first('phoneLabel_' + id)"
          >
            <label-input
              v-model="phone.label"
              v-validate.disable="'max:255'"
              :name="'phoneLabel_' + id"
              labelList="phone"
            />
          </q-field>
        </div>
      </div>
    </q-field>
  </section>
</template>

<script>
  import LabelInput from 'components/Common/Inputs/LabelInput.vue'

  export default {
    inject: ['$validator'],

    props: {
      /**
       * Used for v-model.
       */
      value: {
        type: [Object],
        required: true
      },

      /**
       * Id of the input. Required for multiple address inputs per page
       */
      id: {
        type: Number,
        default: 0
      },

      /**
       * Indicate if the label input should be visible
       */
      label: {
        type: Boolean,
        default: false
      },

      /**
       * Indicate if the label of the address line field should be visible
       */
      hideLabel: {
        type: Boolean,
        default: false
      },

      /**
       * Indicate if the field icon should be visibile
       */
      showIcon: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        phone: this.value
      }
    },

    computed: {
      isEmpty () {
        return !this.phone.number
      },

      columnWidth () {
        return this.isEmpty || !this.label ? 'col-12' : 'col-sm-6 col-12 q-mb-sm'
      }
    },

    watch: {
      value: {
        handler: function (newPhone) {
          this.phone = newPhone
        },
        deep: true
      },

      phone: {
        handler: function (newPhone) {
          this.$emit('input', newPhone)
        },
        deep: true
      }
    },

    components: {
      LabelInput
    }
  }
</script>
